import { InternalApprovalCardController } from './internal-approval-card.controller'

function internalApprovalCard () {
  return {
    restrict: 'E',
    scope: {
      approval: '<',
      task: '<',
      onDelete: '&',
      onUpdate: '&',
      onApproval: '&',
      noInteraction: '<'
    },
    templateUrl: '/workflow/directives/internal-approval-card/internal-approval-card.html?$$REVISION$$',
    controller: InternalApprovalCardController
  }
}

export { internalApprovalCard }
